import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const CONNECTOR_BASE = 'https://social-app.instantdm.com';

export default function SocialRedirect() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const allParams = searchParams.toString();
    const redirectUrl = `${CONNECTOR_BASE}/connect/callback${allParams ? `?${allParams}` : ''}`;
    window.location.replace(redirectUrl);
  }, [searchParams]);

  return null;
}
